import { Museum } from '@Interfaces/dddApi.interfaces';
import { JsonLdOrganization, JsonLdProduct, TipologiaVisita } from '@Interfaces/interfaces';
import { FOOTER_CONST, SEO_CONST } from '@Utils/constants';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root'
})
export class SeoService {
  private selectedMuseums: Museum|null = null;

  constructor(
    private meta: Meta,
    private translateService: TranslateService,
  ) {
    this.translateService.onLangChange
    .subscribe(() => {
      this.updateLangMetaTags();
    });
  }

  private updateLangMetaTags() {
    let metaDescription;
    let metaTitle;
    if (this.selectedMuseums) {
      metaDescription = this.selectedMuseums.denominazione + this.translateService.instant('SeoMetaTag.META_DESCRIPTION_SPEC');
      metaTitle = this.selectedMuseums.denominazione + this.translateService.instant('SeoMetaTag.META_TITLE_SPEC');
    } else {
      metaDescription = this.translateService.instant('SeoMetaTag.META_DESCRIPTION');
      metaTitle = this.translateService.instant('SeoMetaTag.META_TITLE');

    }
    this.meta.updateTag({ name: 'description', content: metaDescription });
    this.meta.updateTag({ property: 'og:description', content: metaDescription });
    this.meta.updateTag({ property: 'og:title', content: metaTitle });
    this.meta.updateTag({ name: 'twitter:title', content: metaTitle });
    this.meta.updateTag({ name: 'twitter:description', content: metaDescription });
  }

  setMetaTagSEO() {
    const logoUrl = document.baseURI + 'assets/images/logo-musei-italiani-header.webp';
    let metaDescription = this.translateService.instant('SeoMetaTag.META_DESCRIPTION');
    let metaTitle = this.translateService.instant('SeoMetaTag.META_TITLE');
    this.meta.addTags([
      { name: 'description', content: metaDescription },
      { name: 'robots', content: 'index, follow, noarchive' },
      { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
      { name: 'theme-color', content: '#FAFAFA' },
      { property: 'og:title', content: metaTitle },
      { property: 'og:description', content: metaDescription },
      { property: 'og:url', content: document.documentURI },
      { property: 'og:image', content: logoUrl },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:title', content: metaTitle },
      { name: 'twitter:description', content: metaDescription },
      { name: 'twitter:image', content: logoUrl }
    ]);
    this.createJsonLdOrganization();
  }

  /* istanbul ignore next */
  updateMetaTagSEO(selectedMuseum:Museum) {
    this.selectedMuseums = selectedMuseum;
    let titleSelectedMuseum = selectedMuseum.denominazione + this.translateService.instant('SeoMetaTag.META_TITLE_SPEC');
    let previuosMuseum = this.meta.getTag('property="og:title"');
    if ( previuosMuseum && previuosMuseum.content != titleSelectedMuseum ) {
      let metaDescription = selectedMuseum.denominazione + this.translateService.instant('SeoMetaTag.META_DESCRIPTION_SPEC');
      let metaTitle = selectedMuseum.denominazione + this.translateService.instant('SeoMetaTag.META_TITLE_SPEC');
      this.meta.updateTag({ name: 'description', content: metaDescription });

      /* meta */
      this.meta.updateTag({ property: 'og:title', content: metaTitle });
      this.meta.updateTag({ property: 'og:description', content: metaDescription });
      this.meta.updateTag({ property: 'og:url', content: document.documentURI });
      this.meta.updateTag({ property: 'og:image', content: selectedMuseum.immagine_copertina });
      /* twitter */
      this.meta.updateTag({ name: 'twitter:title', content: metaTitle});
      this.meta.updateTag({ name: 'twitter:description', content: metaDescription });
      this.meta.updateTag({ name: 'twitter:image', content: selectedMuseum.immagine_copertina });
    }

  }

  createJsonLdOrganization(): void {
    const jsonLdOrganization: JsonLdOrganization  = {
      '@context': 'https://schema.org',
      '@type': SEO_CONST.TYPE_ORGANIZATION,
      address: {
        '@type': 'PostalAddress',
          addressLocality: FOOTER_CONST.CITY,
          postalCode: FOOTER_CONST.POSTAL_CODE,
          streetAddress: FOOTER_CONST.ADDRESS
      },
      url: "https://museiitaliani.it/",
      email: FOOTER_CONST.MAIL,
      name: SEO_CONST.NAME_ORGANIZATION,
      logo: 'https://akamaicdn.museiitaliani.it/museiitaliani-prod/public/img/seo/meta-img.webp'
    };

    this.addJsonLdMetaTag(jsonLdOrganization);
  }

  addJsonLdMetaTag(jsonLd: JsonLdOrganization | JsonLdProduct): void {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(jsonLd);
    document.head.appendChild(script);
  }

  removeJsonLd(typeJsonLd: string): void {
    let scripts = document.querySelectorAll('script[type="application/ld+json"]');
    scripts.forEach(script => {
      let jsonLd = JSON.parse(script.innerHTML);
      if (jsonLd['@type'] === typeJsonLd) {
        script.remove();
      }
    })
  }

}
